import IconWrapper from './iconWrapper';

export default IconWrapper;
